import React from "react";
import cns from "classnames";
import Portal from "@material-ui/core/Portal";
import { makeStyles } from "@material-ui/core/styles";
import { Topbar, TopBarProps } from "../Topbar";

export type EditPageLayoutProps = {
  children?: React.ReactNode;
  stickyPane?: React.ReactNode;
  fitted?: boolean;
  topbarProps?: Partial<TopBarProps>;
};

export function EditPageLayout(props: EditPageLayoutProps) {
  const { children, fitted, stickyPane } = props;
  const classes = useStyles({});

  const className = cns(classes.root, {
    [classes.padded]: !fitted
  });

  return (
    <div className={className}>
      {stickyPane && (
        <Portal>
          <div className={classes.stickyPane}>{stickyPane}</div>
        </Portal>
      )}

      <div style={{ padding: 16, paddingTop: 8, paddingBottom: 8 }}>
        <Topbar {...props.topbarProps} />
      </div>

      {children}
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%"
  },

  padded: {
    marginLeft: theme.spacing(4),
    paddingRight: theme.spacing(4)
  },

  stickyWrapper: {
    position: "absolute",
    top: 64
  },

  stickyPane: {
    position: "fixed",
    top: 64,
    right: 0
  }
}));

export default EditPageLayout;
